import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem } from "@mui/material";
import styles from "./AddUserDialog.module.css";
import { translate } from "../../../../common/providers";
import { CustomDialog, InfiniteListSelector } from "../../../../common/components";
import { BackOfficeService } from "../../../../api";
import { useApi } from "../../../../common/hooks";

export default function AddUserDialog({ companyId, open, onClose, onSubmit }) {
	const { call: getAllUsersByCompany } = useApi(BackOfficeService.getAllUsersByCompany);
	const [selectedUser, setSelectedUser] = useState(null);
	const [usersRequest, setUsersRequest] = useState(null);
	useEffect(() => {
		if (companyId && open) {
			setUsersRequest(
				() =>
					({ limit, page }) =>
						getAllUsersByCompany(
							{ companyId },
							{
								limit,
								page,
							}
						)
			);
		}
	}, [getAllUsersByCompany, open, companyId]);
	const handleSelectUser = (newSelectedUser) => setSelectedUser(newSelectedUser);
	const handleSubmit = () => {
		if (!selectedUser) {
			return;
		}
		onSubmit(selectedUser);
		setSelectedUser(null);
		onClose();
	};
	const handleClose = () => {
		setSelectedUser(null);
		onClose();
	};
	const rowRenderer = ({ loadedRow, onClick }) => (
		<MenuItem key={loadedRow.id} translate="no" onClick={() => onClick(loadedRow)}>
			{loadedRow.displayName} - {loadedRow.email}
		</MenuItem>
	);
	return (
		<CustomDialog
			isForm
			open={open}
			title={translate("dsi.add-user-dialog.add-user-to-project")}
			onClose={handleClose}
			onSubmit={handleSubmit}
		>
			<FormControl
				fullWidth
				className={styles.formControl}
				label={translate("smart-review.redress-dialog.select-action")}
				variant="outlined"
			>
				<InputLabel className={styles.inputLabel}>
					{translate("dsi.add-user-dialog.label.select-user")}
				</InputLabel>
				<InfiniteListSelector
					classNameInfiniteList={styles.infiniteListSelector}
					infiniteListRequest={usersRequest}
					rowRenderer={rowRenderer}
					value={selectedUser ? `${selectedUser.displayName} - ${selectedUser.email}` : ""}
					onClick={handleSelectUser}
				/>
			</FormControl>
		</CustomDialog>
	);
}
